import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');
export default class ManageWorkflow extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
				let parms = "";
				// JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
        console.log("parms => " + parms);

		this.state={
			workflow : {
				"workflowId": JSON.parse(parms).id,
				"workflowName": "",
				"workflowTypeCode": 0,
				"description": "",
				"statusCode": 0,
				"workflowCases" : "",
				"annotations": "",
				"contentId": 0,
				"securityContextId": 0,
				"createUser": 0,
				"createDate": new Date(),
				"lastUpdateUser": 0,
				"lastUpdateDate": new Date(),
				"managerId": 0,
			  	"ownerId": 0,
			  	"assignees": "",
			  	"projectId": 0,
			  	"recipeId": 0
			  },
			  ownerUserName : "",
			  assigneeRA : [],
			  workflowTypeCodeList : [],
			  statusCodeList : [],
			  createUserName : "",
			  lastUpdateUserName : "",
			  projectName : "",
			  recipeName : ""
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		let dataValue = (target.value === null) ? "" : target.value;
		this.setState({ workflow : {...this.state.workflow, [target.id] : dataValue } });
	   
		console.log(this.state);
	  }
	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	
	 	var url = `${global.config.apiServicesUrl}/workflows/${this.state.workflow.workflowId}`;

	  	this.setState({workflow : {...this.state.workflow, lastUpdateUser : Number(this.props.userId) }});
	  	this.setState({workflow : {...this.state.workflow, lastUpdateDate : new Date() }});

		axios.put(url, this.state.workflow)
			.then(response2 => {
			console.log("response.data");
			console.log(response2.status +":"+response2.data.workflowId);
			// && response2.data.contentFacadeId === this.state.workflow.contentFacadeId
			if (response2.status === 200 )
			{
				this.message = "Success";
			}
			else
			{
				 this.message = "Failed";
			}        
			console.log(this.message);
		  }).catch(err => {
			 console.log("error - " + err);
		  });
		console.log("message info - " + this.message); 
		//this.handleClear();
			
	 };
	 handleClear(){
		 this.setState({workflow : {}})
	 }
	 componentDidMount() 
	 {
	 	this.handleOnLoad();
	 }

	handleOnLoad = () => {
      axios.get(`${global.config.apiServicesUrl}/workflows/${this.state.workflow.workflowId}`).then(res => {

	      	this.setState({ workflow : res.data });
    	  	console.log(res.data[0]);

			if (res.data.assignees) {
				this.setState({assigneeRA : res.data.assignees.split(',')});
				//console.log('state.ara -> ' + this.state.assigneeRA);	
				var tempRa = this.state.assigneeRA.map(function  (assignee) {
					var temp = assignee.split('=');
					temp = temp[1].split('/')[0].trim();
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${temp}`)
					.then(response =>{
					temp = response.data;
					}).catch(function (error) {
						console.log("Error:"+error);
					});	
					//console.log("rausername " + temp);
					return temp;
				});
				console.log(tempRa);	
				//alert(tempRa);
				this.setState({assigneeRA : tempRa});
			}			
 			//resolve drop down lists
			{
				//statusCodeList : [],
				var url1 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/TASK_STATUS`;
					axios.get(url1)
					.then(response =>{
 					this.setState({statusCodeList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
				//workflowTypeCodeList
				var url2 = `${global.config.sharedServicesUrl}/code-catalog-data-service/get-system-code-values/WORK_QUEUE`;
					axios.get(url2)
					.then(response =>{
 					this.setState({workflowTypeCodeList : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
			}		 
      	
      		//resolve user names			
				 {
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.workflow.createUser}`)
					.then(response =>{
 					this.setState({createUserName : response.data});
					console.log("createuserid " + response.data);
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.workflow.lastUpdateUser}`)
					.then(response =>{
 					this.setState({lastUpdateUserName : response.data});
					console.log("lastupdateuserid " + response.data);
					}).catch(function (error) {
					console.log("Error:"+error);
					});		
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.workflow.ownerId}`)
					.then(response =>{
 					this.setState({ownerUserName : response.data});
					console.log("ownerid " + response.data);
					}).catch(function (error) {
					console.log("Error:"+error);
					});		
					axios.get(`${global.config.apiServicesUrl}/user-projects/${this.state.workflow.projectId}`)
					.then(response =>{
 					this.setState({projectName : response.data});
					console.log("pname " + response.data);
					}).catch(function (error) {
					console.log("Error:"+error);
					});		
					axios.get(`${global.config.apiServicesUrl}/user-projects/${this.state.workflow.recipeId}`)
					.then(response =>{
 					this.setState({recipeName : response.data});
					console.log("rcpname " + response.data);
					}).catch(function (error) {
					console.log("Error:"+error);
					});		
				}
		})
		.catch(function (error){
		})
	 }
	handleDelete(event)
	{
	 	event.preventDefault();
		axios.delete(`${global.config.apiServicesUrl}/workflows/${this.state.workflow.workflowId}`).then(res => {
  		this.handleClear();
		window.location.href = "/workflows";
  		});
	}
	render(){
    return (
        	<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
		
		<form>
		<div class="container-fluid">
		<h4>Manage Workflow Entry</h4>
		<hr />
		<div class="row">
		<div class="col col-sm-10">
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Workflow Name</label>
		<input id="workflowName" class="form-control input-medium col-sm-8" value={this.state.workflow.workflowName} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Workflow Owner</label>
		<input id="ownerUserName" class="form-control input-medium col-sm-8" value={this.state.ownerUserName} onChange ={this.handleChange}/>
		</div>

			<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Workflow Status</label>
			<select id="statusCode" class="form-control input-medium col-sm-8" value={this.state.workflow.statusCode} onChange ={this.handleChange}>
			{
				this.state.statusCodeList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>			
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Description</label>
			<input id="description" class="form-control input-medium col-sm-8" value={this.state.workflow.description} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Workflow Type</label>
			<select id="workflowTypeCode" class="form-control input-medium col-sm-8" value={this.state.workflow.workflowTypeCode} onChange ={this.handleChange}>
			{
				this.state.workflowTypeCodeList.map((status) => {
					return (
						<option key={status.systemCodeValueId} value={status.systemCodeValueId}>{status.systemCodeValueValue}</option>
					)
				})
			}
			</select>			
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Cases</label>
			<input id="workflowCases" class="form-control input-medium col-sm-8" value={this.state.workflow.workflowCases} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Annotations</label>
			<input id="annotations" class="form-control input-medium col-sm-8" value={this.state.workflow.annotations} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Content</label>
			<select id="contentId" class="form-control input-medium col-sm-8" value={this.state.workflow.contentId} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Manager</label>
			<select id="managerId" class="form-control input-medium col-sm-8" value={this.state.workflow.managerId} onChange ={this.handleChange}/>
			</div>
			{/*
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Assignees</label>
			<input id="assignees" class="form-control input-medium col-sm-8" value={this.state.workflow.assignees} onChange ={this.handleChange}/>
			</div>
			*/}
			<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Project</label>
			<input id="projectName" class="form-control input-medium col-sm-8" value={this.state.projectName} onChange ={this.handleChange}/>
			</div>
				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Recipe</label>
			<input id="recipeName" class="form-control input-medium col-sm-8" value={this.state.recipeName} onChange ={this.handleChange}/>
			</div>

		

				<hr/>
			<div class="form-group row" >
				<label class="ContentTitle col-sm-2" >Created By</label>
				<input id="createUserName" class="form-control input-medium col-sm-2" value={this.state.createUserName} />
				<label class="ContentTitle col-sm-1" > On </label>
				<input id="createDate" class="form-control input-medium col-sm-2" value={String(this.state.workflow.createDate).substring(0,10)} />
			</div>
			<div class="form-group row" >
				<label class="ContentTitle col-sm-2" >Last Updated By</label>
				<input id="lastUpdateUserName" class="form-control input-medium col-sm-2" value={this.state.lastUpdateUserName} />
				<label class="ContentTitle col-sm-1" > On </label>
				<input id="lastUpdateDate" class="form-control input-medium col-sm-2" value={String(this.state.workflow.lastUpdateDate).substring(0,10)} />
			</div>
		<hr />	
					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Save" onClick ={this.handleSubmit}>Save</button>&nbsp;
					<button class="btn btn-danger" value="Delete" onClick ={this.handleDelete}>Delete</button> 
		</div>		
		
					<div class="col col-sm2">
				<h4>Contacts</h4>
				<div className="form-group row">
					<table class="table table-bordered table-striped">
  					<tbody>

			          {this.state.assigneeRA.map( function ( assignee ) {
  						  return <tr>
							<td><img src={require("../../images/gazelle.png")} width="24"></img></td>
							<td><Link to={{ pathname: "#", search : `?id=${assignee}` }}>{assignee}</Link></td>
  					  	</tr>
						}) 
					}
		        	</tbody>
			        </table>

				{/*
				{
					this.state.circleContactsRA
				}
			    */}
      			</div>
				
				
			</div>

		
			</div>

		</div>		
		</form>
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
	);
}
}